@if (formGroup) {
  <div class="edit-filter-content">
    <dv-dialog-content>
      @if (!isLoading()) {
        <dv-dynamic-form
          [elements]="filterNameElements | translateElements"
          [formGroup]="formGroup">
        </dv-dynamic-form>
        <hr class="form-divider" />
        <dv-dynamic-form
          formTitle="{{
            'FilterEdit.DriverAndDepartment' | translate | uppercase
          }}"
          class="dynamic-form-background"
          [elements]="driverAndDepartmentElements | translateElements"
          [formGroup]="formGroup">
        </dv-dynamic-form>
        <hr class="form-divider" />
        <dv-dynamic-form
          class="period-elements-wrapper"
          formTitle="{{
            'FilterEdit.PeriodAndInterval' | translate | uppercase
          }}"
          [elements]="periodElements | translateElements"
          [formGroup]="formGroup">
        </dv-dynamic-form>
        <dv-dynamic-form
          [elements]="intervalElements | translateElements"
          [formGroup]="formGroup">
        </dv-dynamic-form>
        <hr class="form-divider" />
        <dv-dynamic-form
          class="dynamic-form-background"
          formTitle="{{ 'FilterEdit.Distance' | translate | uppercase }}"
          [elements]="distanceElements | translateElements"
          [formGroup]="formGroup">
        </dv-dynamic-form>
        <hr class="form-divider" />
        <div class="form-title">
          {{ 'FilterEdit.OtherFilter' | translate | uppercase }}
        </div>
        <div class="other-filters-grid">
          <dv-grid [actions]="actions">
            <ag-grid-angular
              class="ag-theme-devinco"
              [gridOptions]="gridOptions"
              [rowData]="[{}]"
              [popupParent]="popupParent"
              (filterChanged)="onGridFilterChanged($event)"
              (gridReady)="onGridReady($event)"></ag-grid-angular>
          </dv-grid>
        </div>
        <dv-dynamic-form
          [elements]="permissionElements | translateElements"
          [formGroup]="formGroup">
        </dv-dynamic-form>
      }
      <dv-button footer-right (click)="cancel()">
        {{ 'General.Cancel' | translate }}
      </dv-button>
      <dv-button
        footer-right
        color="secondary"
        (click)="performSave()"
        [disabled]="!this.formGroup.valid || !this.formGroup.dirty">
        {{ 'General.Confirm' | translate }}
      </dv-button>
    </dv-dialog-content>
  </div>
}
